import { useEffect, useState } from 'react';
import { List } from '../components/Details.styles';

import { compare } from '../../../../utils/order/compare';
import { DadosGE, Service } from '../../interfaces/ResponseProduct';
import { Options } from '../interface/Options';
import { formatMonetary } from '../../../../utils/format/FormatMonetary';

export default function Warranty({ options }: Options) {

  const [buyOptions, setBuyOptions] = useState<DadosGE[]>([]);

  useEffect(() => {
    let newOptions: DadosGE[] = [];

    if (options.length > 0) {
      options[0].dadosDinamica.servicos?.map((dado: Service) => {
        if (dado.dadosGE[0].length) {
          newOptions = dado.dadosGE[0]
        }
        return dado;
      });

      setBuyOptions(newOptions.sort((a: any, b: any) => compare(a, b, 'quantidadeDeParcelas')));
    }
  }, [options]);

  if (!buyOptions.length) {
    return <List>Nenhuma Garantia Disponível.</List>
  }

  return (
    <>
      {buyOptions.map((item: DadosGE, index: number) => (
        <List key={`table-row-security-${index}`}>
          {`R$ ${formatMonetary(item.valorGe)} por ${item.tempoEstendido} meses - após o término da garantia do fabricante.`}
        </List>
      ))}
    </>
  );
}
